import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import jobsData from '../data/jobs';

export function useJobs() {
    const { t } = useTranslation('jobs');

    return useMemo(
        () =>
            jobsData.map((job, index) => ({
                ...job,
                title: t(`${index}.title`),
                place: t(`${index}.place`),
                time: t(`${index}.time`),
                description: t(`${index}.description`),
                responsibilities: t(`${index}.responsibilities`, { returnObjects: true }),
                requirements: t(`${index}.requirements`, { returnObjects: true }),
                atouts: t(`${index}.atouts`, { returnObjects: true }),
            })),
        [t]
    );
}
